import { render } from "./HalloweenOverlay.vue?vue&type=template&id=734173ef&scoped=true"
import script from "./HalloweenOverlay.vue?vue&type=script&lang=js"
export * from "./HalloweenOverlay.vue?vue&type=script&lang=js"

import "./HalloweenOverlay.vue?vue&type=style&index=0&id=734173ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734173ef"]])

export default __exports__